export default __webpack_public_path__ + "static/media/contact-form.610e0d53.png";